import { getVehicleFuelSubcategory } from "../../../../../apis/Business/FuelVehicleApi";
import { getOtherVehicleSubcategory } from "../../../../../apis/Business/Business";
import { getIngoingTransportSubcategory } from "../../../../../apis/Business/IngoingTransportApi";
import { getOutgoingTransportSubcategory } from "../../../../../apis/Business/OutgoingTransportApi";
import { getCustomSubcategory } from "../../../../../apis/Business/InventoryApi";
import { getTravelSubcategory } from "../../../../../apis/Business/TravelApi";
import { getWasteSubcategory } from "../../../../../apis/Business/WasteApi";
import { getVehicleSubcategory } from "../../../../../apis/Business/Business";

const getCustomSubcategories = async (category, businessId) => {
  // Mapping of categories to their respective subcategory fetching functions
  const subcategoryFunctions = {
    "Registered Vehicle": getVehicleSubcategory,
    "Fuel Vehicle": getVehicleFuelSubcategory,
    "Other Vehicle": getOtherVehicleSubcategory,
    "Ingoing Transport": getIngoingTransportSubcategory,
    "Outgoing Transport": getOutgoingTransportSubcategory,
    "Business Travel and Hotel Stays": getTravelSubcategory,
    "Employee Commute": getTravelSubcategory,
    "Surplus Resources": getWasteSubcategory,
    Inventory: getCustomSubcategory,
    Remote: () => Promise.resolve([]), // No subcategories for Remote
  };

  // Check if there's a specific function for this category
  const fetchFunction = subcategoryFunctions[category];

  if (!fetchFunction) {
    console.warn(
      `No subcategory fetching function found for category: ${category}`
    );
    return [];
  }

  try {
    // Wrap the fetch in a Promise to handle async operation
    const subcategories = await new Promise((resolve) => {
      fetchFunction({
        businessId,
        setSubcategoryNames: (data) => resolve(data),
      });
    });

    // Transform the subcategories into the format used in your dropdowns
    return subcategories.map((subcategory, index) => ({
      id: index + 1,
      title: subcategory,
      name: subcategory,
      value: subcategory,
      label: subcategory,
    }));
  } catch (error) {
    console.error(`Error fetching subcategories for ${category}:`, error);
    return [];
  }
};

export default getCustomSubcategories;
